import { Controller } from "@hotwired/stimulus"

// 個票生成フォームで DI / GI 選択に応じて表示要素を切り替える。
// DI: インタビュー日時は各候補者の確定日時を自動取得 / GI セッション名は不要
// GI: 1 セッション = 1 シートのため、 共通の インタビュー日時 と セッション名 を表示
// submit 時には設問が 1 つ以上選択されていることを検証する。
export default class extends Controller {
  static targets = ["giOnly", "questionCheckbox"]

  connect() {
    this.update()
  }

  update() {
    const selected = this.element.querySelector("input[name='format']:checked")
    const format = selected ? selected.value : "di"
    const showGi = format === "gi"
    this.giOnlyTargets.forEach(el => {
      el.classList.toggle("hidden", !showGi)
    })
  }

  validate(event) {
    if (!this.hasQuestionCheckboxTarget) return
    const anyChecked = this.questionCheckboxTargets.some(c => c.checked)
    if (!anyChecked) {
      event.preventDefault()
      window.alert("出力する設問を 1 つ以上選択してください")
    }
  }
}
